import axios from 'axios';
import intl from 'react-intl-universal';
import qs from 'qs';
import { store } from 'Store/store.index';
import { HttpRequest } from './request.utils';
import { baseUrlApis } from 'Api/index';
import { URL_APPSTORE_API } from 'Api/constants';

export default class PaymentApi extends HttpRequest {
  constructor() {
    super();
    this.paymentAxios = null;
    this.payDomain = '';
    this.init();
  }

  init() {
    try {
      baseUrlApis.getBaseUrlBy(URL_APPSTORE_API).then(data => {
        this.payDomain = data;
        this.paymentAxios = axios.create({
          baseURL: this.payDomain,
        });
        super.initialize(this.paymentAxios, () => {
          let responseCfg = {
            success: (res) => {
              return res.data;
            },
            error: (error) => {
              this.errorHandler(error);
              return Promise.reject(error);
            },
          };
          this.interceptorsProxyFn(null, responseCfg);
        });
      });
    } catch (e) {
      throw e;
    }
  }

  errorHandler(error) {
    let errorMsg;
    if (error.__CANCEL__) {
      errorMsg = intl.formatMessage({ id: 'CancelRequest' });
    } else {
      errorMsg = intl.formatMessage({ id: 'NetworkError' });
    }
    store.appStore.setGlobalMessage({ type: 'error', content: errorMsg });
  }

  // 币种 currency
  getCurrency(token, email) {
    const other = email ? { email } : {};
    return this.get({
      url: '/api/e-commerce/currency',
      config: {
        params: {
          'access-token': token,
          ...other,
        },
      },
    });
  }

  // 国家 country
  getCountry(token) {
    return this.get({
      url: '/api/e-commerce/country',
      config: {
        params: {
          'access-token': token,
        },
      },
    });
  }

  // 国家下的州 ，省等
  getCountryState(country, token) {
    return this.get({
      url: '/api/e-commerce/country-state',
      config: {
        params: {
          country,
          'access-token': token,
        },
      },
    });
  }

  // pay prices
  getPaymentPlans({ country, language, currency, token, ip, app_code = 'phantom_ga_online' }) {
    return this.get({
      url: '/api/e-commerce/prices',
      config: {
        params: {
          country,
          language,
          currency,
          ip,
          app_code,
          'access-token': token,
          qty: 1,
        },
      },
    });
  }

  //plan
  getPlanId({ token, currency, price, type, trial_period_days,country,ip,language, app_code = 'phantom_ga_online' }) {
    if (trial_period_days) {
      return this.post({
        url: '/api/e-commerce/plan',
        config: {
          params: {
            'access-token': token,
          },
        },
        data: {
          app_code,
          currency,
          price,
          type,
          trial_period_days,
          qty: 1,
          country,
          ip,
          language,
        },
      });
    } else {
      return this.post({
        url: '/api/e-commerce/plan',
        config: {
          params: {
            'access-token': token,
          },
        },
        data: {
          app_code,
          currency,
          price,
          type,
          qty: 1,
          country,
          ip,
          language,
        },
      });
    }
  }

  // card list
  getCards({ token }) {
    return this.get({
      url: '/api/e-commerce/cards',
      config: {
        params: {
          'access-token': token,
        },
      },
    });
  }

  getCardInfo({ token, payment_method_id }) {
    return this.get({
      url: `/api/e-commerce/card/${payment_method_id}`,
      config: {
        params: {
          'access-token': token,
        },
      },
    });
  }

  // bind card
  bindCard({
    token,
    payment_method_id,
  }) {
    return this.patch({
      url: `/api/e-commerce/card/${payment_method_id}/bind`,
      config: {
        params: {
          'access-token': token,
        },
      },
    });
  }

  // setDefault card
  defaultCard({
    token,
    payment_method_id,
  }) {
    return this.patch({
      url: `/api/e-commerce/card/${payment_method_id}/default`,
      config: {
        params: {
          'access-token': token,
        },
      },
    });
  }

  // user tax
  getTax({
    token,
    name,
    country_code,
    is_eu_country,
    state_code,
    city,
    zip,
    address,
    plan_id,
    vat_number,
    abn_number,
    company,
  }) {
    let data = {
      country_code,
      plan_id,
      name,
      company,
      state_code,
      city,
      zip,
      address,
    };

    if (is_eu_country) {
      Object.assign(data, { vat_number, vat_company: company });
    }
    if (['AU'].includes(country_code)) {
      Object.assign(data, { abn_number, abn_certify: 1 });
    }

    return this.post({
      url: '/api/e-commerce/tax',
      config: {
        params: {
          'access-token': token,
        },
      },
      data,
    });
  }

  // subscribe
  subscribePlan({ token, stripe_plan_id, tax_rate, lang, renewal, sign, ip, address, zip, city, state_code, country_code, ga_client_id }) {
    return this.post({
      url: '/api/e-commerce/subscription',
      config: {
        params: {
          'access-token': token,
        },
      },
      data: {
        stripe_plan_id,
        license_num: 1,
        tax_rate,
        lang,
        renewal,
        sign,
        address, zip, city, state_code, country_code, ip, ga_client_id,
      },
    });
  }

  /**
   *
   * 查重 APi备注
   * 创建订单：POST /rest/api/paper/order
   *   更新下面信息
   checkLetterCounts,   letter_counts
   checkFileType,       file_type
   checkType,           type
   checkEngine,         engine
   checkTotalPrice      total_price
   checkTitle,          title
   checkAuthor          author
   checkPublishDate     abstract_date
   *
   *
   * 开始检查的时候更新 checkId  :PATCH /rest/api/paper/order/{order_id}/check
   * 失败的时候 更新 error_type(checkErrorType): PATCH /rest/api/paper/order/{order_id}/failure
   * 成功的时候 更新copy_percent(checkTotalCopyPercent):PATCH /rest/api/paper/order/{order_id}/finish
   * 订单信息（查重历史） GET /rest/api/paper/orders
   * 价格信息 GET /rest/api/paper/prices
   * **/
  createPaperCheckOrder(formData, sign) {
    return this.post({
      url: '/rest/api/paper/order',
      data: qs.stringify(formData),
      config: {
        params: {
          'access-token': store.userStore.token,
          sign,
        },
      },
    });
  }

  getPaperCheckOrderDetail(orderId) {
    return this.get({
      url: `/rest/api/paper/order/${orderId}`,
      config: {
        params: {
          'access-token': store.userStore.token,
        },
      },
    });
  }

  updatePaperCheckId(orderId, checkId) {
    return this.patch({
      url: `/rest/api/paper/order/${orderId}/check`,
      data: qs.stringify({
        checkId,
      }),
      config: {
        params: {
          'access-token': store.userStore.token,
        },
      },
    });
  }

  updatePaperCheckErrorType(orderId, checkErrorType) {
    return this.patch({
      url: `/rest/api/paper/order/${orderId}/failure`,
      data: qs.stringify({
        error_type: checkErrorType,
      }),
      config: {
        params: {
          'access-token': store.userStore.token,
        },
      },
    });
  }

  updatePaperCheckCopyPercent(orderId, checkTotalCopyPercent) {
    return this.patch({
      url: `/rest/api/paper/order/${orderId}/finish`,
      data: qs.stringify({
        copy_percent: checkTotalCopyPercent,
      }),
      config: {
        params: {
          'access-token': store.userStore.token,
        },
      },
    });
  }

  getPaperCheckPaymentInfo(orderId, pay_type = 'Wechat') { // /rest/api/paper/order/{order_id}/pay
    return this.post({
      url: `/rest/api/paper/order/${orderId}/pay`,
      data: qs.stringify({ order_id: orderId, pay_type }),
      config: {
        params: {
          'access-token': store.userStore.token,
        },
      },
    });
  }

  getPaperCheckOrders(page = 0, pageSize = 100) {
    return this.get({
      url: '/rest/api/paper/orders',
      config: {
        params: {
          'access-token': store.userStore.token,
          page,
          pageSize,
        },
      },
    });
  }

  getPaperPrices() {
    return this.get({
      url: '/rest/api/paper/prices',
      config: {
        params: {
          'access-token': store.userStore.token,
        },
      },
    });
  }
}
